import {useEffect, useRef} from "react";
import Image from "next/image";
import Container from "./Container";
import {moveImageBox} from "../helpers/animations";

export default function TextWithImageAlt({
                                             image,
                                             imageAlt = '',
                                             imageRatio = '',
                                             childrenClasses = 'max-w-md',
                                             children,
                                             imageOffset = 0.08,
                                             boxOffset = -0.1,
                                             minWinSize = 768
                                         }) {

    const refImage = useRef();
    const refBox = useRef();

    useEffect(() => {
        const handleScroll = () => {
            if (refImage.current && refBox.current) {
                moveImageBox(refImage, refBox, imageOffset, boxOffset, minWinSize);
            }
        };

        window?.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window?.removeEventListener('scroll', handleScroll);
    }, [boxOffset, imageOffset, minWinSize]);

    return (
        <Container>
            <section className="flex flex-col md:flex-row items-center md:items-stretch md:gap-20 md:gap-16">

                <div className="relative w-full flex-1">
                    <div
                        className="block absolute w-[60%] aspect-[6/7] top-2/4 md:top-1/3 left-1 md:left-[50%] lg:left-[45%] bg-white shadow-lg rounded-md ease-out transition-transform duration-500"
                        ref={refBox}
                    />

                    <div
                        className={`relative flex ml-auto rounded-md overflow-hidden ease-out transition-transform duration-1000 will-change-transform ${imageRatio}`}
                        ref={refImage}>
                        <Image src={image}
                               className="will-change-transform transition-transform ease-out duration-1000"
                               alt={imageAlt}
                        />
                    </div>
                </div>

                <div className="relative flex-1">
                    <div className={childrenClasses}>
                        {children}
                    </div>
                </div>
            </section>
        </Container>
    )
}
